import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import CampoNroTelefono from "../../generico/CampoNroTelefono";
import Select from "react-select";
import DatosPersonalesService from "../../../services/administracion/DatosPersonalesService";
import AuthService from "../../../services/login/auth.service";
import { trackPromise } from "react-promise-tracker";
import { mensajeExito } from "../../generico/MensajeSistemaToast";
import { phoneNumberValido } from "../../generico/utils/FormatoInput";
import Popup from "react-popup";
import Confirmacion from "./Confirmacion";
import MensajeUsuario from "../../generico/MensajeUsuario";
import $ from "jquery";
import MapaUbicacion from "./MapaUbicacion";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faBuilding,faPhone,faMobile,faUserCircle, faFloppyDisk} from "@fortawesome/free-solid-svg-icons";
import ConfigService from "../../../services/configuracion/ConfigService";

var PUBLICO_SI =
  "Para cumplir con la resolución, deberá completar el formulario en carácter de declaración jurada Formulario SEPRELAD debiendo presentarlo firmado en cualquiera de las sucursales en un plazo de 30 días.";
var PUBLICO_NO =
  "Para cumplir con la resolución, deberá completar el formulario en carácter de declaración jurada Formulario SEPRELAD al momento de presentarse en cualquiera de las sucursales.";

export default class DatosPersonales extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentDidMount() {
    this.loadDepartamentos(true);
    this.loadListaCiudades(AuthService.getSocio().departamento, true);
    this.loadListaBarrios(AuthService.getSocio().ciudad, true);
    this.cargarDatosUser();
    var actualizar = ConfigService.getPathByName("actualizarCelular");
    if(actualizar == null){
      this.setState({ actualizarCelular: false });
    } else {
      this.setState({ actualizarCelular: true });
    }
  }

  initDCB(_lista, _key, _tipo) {
    var data = this.findDCB(_lista, Number(_key));
    if(data.length > 0){
      var _label = data[0].label;
      if (_tipo === "D")
        this.setState({ departamento: { value: _key, label: _label } });
      else if (_tipo === "C")
        this.setState({ ciudad: { value: _key, label: _label } });
      else if (_tipo === "B"){
        this.setState({ barrio: { value: _key, label: _label } });
      }
        
    }
    
  }

  findDCB(array, id) {
    var foundItems = $.grep(array, function (v) {
      if (id !== null){
        return v.value === id;
      }
    });
    return foundItems;
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  getInitialState = () => ({
    departamentoList: [],
    ciudadList: [],
    barrioList: [],
    departamento: this.initCombos,
    ciudad: this.initCombos,
    barrio: this.initCombos,
    correo: "",
    telefonoParticular: "",
    celular: AuthService.getSocio().celular,
    celularRaw: "",
    direccionParticular: "",
    entidadLaboral: "",
    cargo: "",
    puestoPublico: "",
    mensaje: "",
    latitud: undefined,
    longitud: undefined,
    actualizarCelular:false
  });
  limpiarCampos = () => ({
    ciudadList: [],
    barrioList: [],
    departamento: this.initCombos,
    ciudad: this.initCombos,
    barrio: this.initCombos,
    correo: "",
    telefonoParticular: "",
    celular: "",
    celularRaw: "",
    direccionParticular: "",
    entidadLaboral: "",
    cargo: "",
    puestoPublico: "",
    latitud: undefined,
    longitud: undefined
  });
  initCombos = () => ({ value: undefined, label: "--Seleccione--" });

  listadoDBC(_tipo, _filtro) {
    var respuesta = [];
    trackPromise(
      DatosPersonalesService.listadoDBC(_tipo, _filtro).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigo === 0) {
          respuesta = jData.datos;
          return respuesta;
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  cargarDatosUser() {
    console.log("cargarDatosUser")
    console.log(AuthService.getSocio().latitud)
    console.log(AuthService.getSocio().longitud)
    this.setState({
      telefonoParticular:
        AuthService.getSocio().telefonoParticular === null
          ? ""
          : AuthService.getSocio().telefonoParticular,
      correo:
        AuthService.getSocio().correoElectronico === null
          ? ""
          : AuthService.getSocio().correoElectronico,
      celular:
        AuthService.getSocio().celular === null
          ? ""
          : AuthService.getSocio().celular,
      celularRaw: "(0988)888-999",
      direccionParticular:
        AuthService.getSocio().direccionParticular === null
          ? ""
          : AuthService.getSocio().direccionParticular,
      entidadLaboral:
        AuthService.getSocio().entidadLaboral === null
          ? ""
          : AuthService.getSocio().entidadLaboral,
      cargo:
        AuthService.getSocio().cargo === null
          ? ""
          : AuthService.getSocio().cargo,
      puestoPublico:
        AuthService.getSocio().puestoPublico === null
          ? ""
          : AuthService.getSocio().puestoPublico,
      mensaje:
        AuthService.getSocio().puestoPublico === "S" ? PUBLICO_SI : PUBLICO_NO,
      barrio:
        AuthService.getSocio().barrio === null
          ? ""
          : AuthService.getSocio().barrio,
      ciudad:
        AuthService.getSocio().ciudad === null
          ? ""
          : AuthService.getSocio().ciudad,
      departamento:
        AuthService.getSocio().departamento === null
          ? ""
          : AuthService.getSocio().departamento,
      presentadoPEPS:
        AuthService.getSocio().presentadoPEPS === null 
          ? null
          : AuthService.getSocio().presentadoPEPS,
      latitud:
        AuthService.getSocio().latitud === null 
          ? null
          : Number(AuthService.getSocio().latitud),
      longitud:
        AuthService.getSocio().longitud === null 
          ? null
          : Number(AuthService.getSocio().longitud),    
    });
  }

  loadDepartamentos(isInit) {
    trackPromise(
      DatosPersonalesService.listadoDBC("D", "").then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigo === 0) {
          var lista = jData.datos;
          var options = [];
          for (var i = 0; i < lista.length; i++) {
            options.push({
              value: lista[i].identificador,
              label: lista[i].descripcion,
            });
          }
          this.setState({ departamentoList: options });
          if (isInit) {
            var key = AuthService.getSocio().departamento;
            this.initDCB(options, key, "D");
          }
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }
  changeDepa = (_depa) => {
    var value = _depa === null ? "" : _depa.value;
    if (value === "") {
      this.setState({
        departamento: this.initCombos,
        //ciudad: this.initCombos,
        //barrio: this.initCombos,
        ciudadList: [],
        barrioList: [],
      });
    } else {
      this.setState(
        {
          departamento: _depa,
          ciudad: this.initCombos,
          barrio: this.initCombos,
        },
        this.loadListaCiudades(value, false)
      );
    }
  };
  changeCity = (_city) => {
    var value = _city === null ? "" : _city.value;
    if (value === "") {
      this.setState({
        ciudad: this.initCombos,
        barrio: this.initCombos,
        barrioList: [],
      });
    } else {
      this.setState(
        { ciudad: _city, barrio: this.initCombos },
        this.loadListaBarrios(value, false)
      );
    }
  };
  changeBarrio = (_barrio) => {
    this.setState({ barrio: _barrio });
  };
  listaDepartamento() {
    return (
      <div className="form-group">
        <label className="input-label-bold">Departamento *</label>
        <Select
          name="departamento"
          value={this.state.departamento}
          onChange={this.changeDepa}
          placeholder="-- Seleccione --"
          options={this.state.departamentoList}
          isClearable
          noOptionsMessage={() => "SIN DATOS"}
        />
      </div>
    );
  }

  loadListaCiudades(_filtro, isInit) {
    if(_filtro !== null){
      trackPromise(
        DatosPersonalesService.listadoDBC("C", _filtro).then((response) => {
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);
          if (jData.codigo === 0) {
            var lista = jData.datos;
            var options = [];
            for (var i = 0; i < lista.length; i++) {
              options.push({
                value: lista[i].identificador,
                label: lista[i].descripcion,
              });
            }
            this.setState({ ciudadList: options });
            if (isInit) {
              var key = AuthService.getSocio().ciudad;
              this.initDCB(options, key, "C");
            }
          }
        })
      ).catch(function (error) {
        console.log(error);
      });
    }
    
  }

  listaCiudades() {
    return (
      <div className="form-group">
        <label className="input-label-bold">Ciudades *</label>
        <Select
          name="ciudad"
          value={this.state.ciudad}
          onChange={this.changeCity}
          placeholder="-- Seleccione --"
          options={this.state.ciudadList}
          isClearable
          noOptionsMessage={() => "SIN DATOS"}
        />
      </div>
    );
  }
  loadListaBarrios(_filtro, isInit) {
    if(_filtro !== null){
      trackPromise(
        DatosPersonalesService.listadoDBC("B", _filtro).then((response) => {
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);
          if (jData.codigo === 0) {
            var lista = jData.datos;
            var options = [];
            for (var i = 0; i < lista.length; i++) {
              options.push({
                value: lista[i].identificador,
                label: lista[i].descripcion,
              });
            }
            this.setState({ barrioList: options });
            if (isInit) {
              var key = AuthService.getSocio().barrio;
              this.initDCB(options, key, "B");
            }
          }
        })
      ).catch(function (error) {
        console.log(error);
      });
    }
    
  }

  listaBarrios() {
    return (
      <div className="form-group">
        <label className="input-label-bold">Barrios *</label>
        <Select
          name="barrio"
          value={this.state.barrio}
          onChange={this.changeBarrio}
          placeholder="-- Seleccione --"
          options={this.state.barrioList}
          isClearable
          noOptionsMessage={() => "SIN DATOS"}
        />
      </div>
    );
  }

  guardar = () => {
    const {
      departamento,
      ciudad,
      correo,
      telefonoParticular,
      celular,
      direccionParticular,
      entidadLaboral,
      cargo,
      puestoPublico,
      barrio,
      presentadoPEPS,
      latitud,
      longitud
    } = this.state;

    trackPromise(
      DatosPersonalesService.actualizarDatos(
        correo,
        telefonoParticular,
        celular,
        direccionParticular,
        departamento.value,
        ciudad.value,
        barrio.value,
        entidadLaboral,
        cargo,
        puestoPublico,
        presentadoPEPS,
        latitud.toString(),
        longitud.toString()
      ).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigo === 0) {
          mensajeExito("Datos actualizados");
          AuthService.loadSocio(AuthService.getCurrentToken());
          //Confirmacion.handleClickConfirmar();
          this.linkSeprelad.click();
          this.modalCtrlConfirm.click();
        } else {
          Popup.queue(this.notifiPopup("Error", jData.mensaje));
        }
      })
    ).catch(function (error) {
      console.log("error");
      console.log(error);
    });
  };

  phoneSelectorValue = (_telefono) => {
    this.setState({
      celularRaw: _telefono,
      celular: this.formatearPhone(_telefono),
    });
  };
  formatearPhone = (valor) => {
    valor = valor.replace("(", "");
    valor = valor.replace(")", "");
    valor = valor.replace("-", "");
    return valor;
  };

  ubiLatitudLongitud = (value) => {
    this.setState({
      latitud: value.latitud,
      longitud:value.longitud
    });
  };

  validate = (e) => {
    $.validator.addMethod("prefijos", (value, element) => {
      return phoneNumberValido(value);
    });
    //// control de ubicación en el mapa
    if(this.state.latitud=== undefined || this.state.longitud === undefined ||
      this.state.latitud=== null || this.state.longitud === null){
      Popup.queue(this.notifiPopup("Atención", "Favor seleccionar la ubicación de su Dirección Particular en el mapa."));
      return false;
    }

    $("#idFormDatosPersonales").validate({
      submitHandler: () => {
        this.guardar();
      },
      ignore: "input[type='text']:hidden",
      rules: {
        correo: {
          required: true,
          email: true,
        },
        telefonoParticular: {
          required: true,
        },
        departamento: {
          required: true,
        },
        ciudad: {
          required: true,
        },
        barrio: {
          required: true,
        },
        direccion: {
          required: true,
        },
        entidad: {
          required: true,
        },
        cargo: {
          required: true,
        },
        funcionPublica: {
          required: true,
        },
        telefono: {
          required: true,
          prefijos: { prefijos: true },
        },
      },
      messages: {
        correo: {
          required: "Este campo es requerido",
          email: "Email inválido",
        },
        telefonoParticular: {
          required: "Este campo es requerido",
        },
        departamento: {
          required: "Este campo es requerido",
        },
        ciudad: {
          required: "Este campo es requerido",
        },
        barrio: {
          required: "Este campo es requerido",
        },
        direccion: {
          required: "Este campo es requerido",
        },
        entidad: {
          required: "Este campo es requerido",
        },
        cargo: {
          required: "Este campo es requerido",
        },
        funcionPublica: {
          required: "Este campo es requerido",
        },
        telefono: {
          required: "Este campo es requerido",
          prefijos: "Número inválido",
        },
      },
      errorElement: "span",
      errorPlacement: function (error, element) {
        error.addClass("invalid-feedback");
        element.closest(".form-group").append(error);
      },
      highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass("is-invalid");
      },
    });
  };

  loadDataConfirm() {
    this.modalCtrlConfirm.click();
  }

  render() {
    return (
      <div className="content-wrapper">
        <form
          id="idFormDatosPersonales"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Confirmacion mensaje={this.state.mensaje} />
          <Titulo texto="Datos Personales" />
          <section className="content">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div
                          className="col-lg-6 col-md-12 col-sm-6 align-items-stretch"
                          style={{ display: "grid" }}>
                          <div className="card card-perfil">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-lg-3 col-md-4 user-circle">
                                  <FontAwesomeIcon icon={faUserCircle} style={{fontSize: 100,
                                      color: "#20a195",
                                      opacity: 0.7,}} />
                                 
                                </div>
                                <div className="col-lg-9 col-md-8">
                                  <h2 className="lead">
                                    <b>
                                      {AuthService.getSocio().nombreCompleto}
                                    </b>
                                  </h2>
                                  <h6 className="text-muted border-bottom-0">
                                    Socio Nro.{" "}
                                    {AuthService.getSocio().numeroSocio.trim()}
                                  </h6>
                                  <ul className="ml-4 mb-0 fa-ul text-muted">
                                    <li
                                      className="small"
                                      style={{ padding: 2 }}
                                    >
                                      <span className="fa-li">
                                        <FontAwesomeIcon icon={faBuilding} />
                                      </span>{" "}
                                      {this.state.direccionParticular},
                                      {this.state.ciudad.label},{" "}
                                      {this.state.departamento.label}{" "}
                                    </li>
                                    <li
                                      className="small"
                                      style={{ padding: 2 }}
                                    >
                                      <span className="fa-li">
                                        <FontAwesomeIcon icon={faPhone} />
                                      </span>{" "}
                                      {this.state.telefonoParticular}
                                    </li>
                                    <li
                                      className="small"
                                      style={{ padding: 2 }}
                                    >
                                      <span className="fa-li">
                                        <FontAwesomeIcon icon={faMobile} />
                                      </span>{" "}
                                      {this.state.celular}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label className="input-label-bold">
                                  Correo Electrónico *
                                </label>
                                <input
                                  name="correo"
                                  value={this.state.correo}
                                  onChange={(e) => {
                                    this.setState({
                                      correo: e.currentTarget.value,
                                    });
                                  }}
                                  type="text"
                                  className="input-box form-control"
                                  style={{textTransform: "lowercase"}}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="input-label-bold">
                                  Teléfono Particular *
                                </label>
                                <input
                                  value={this.state.telefonoParticular}
                                  disabled={!this.state.actualizarCelular}
                                  name="telefonoParticular"
                                  onChange={(e) => {
                                    this.setState({
                                      telefonoParticular: e.currentTarget.value,
                                    });
                                  }}
                                  type="number"
                                  className="input-box form-control"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <CampoNroTelefono
                                phoneSelectorValue={this.phoneSelectorValue.bind(
                                  this
                                )}
                                phoneSelector={this.state.celular}
                                label="Teléfono de Contacto *"
                                disabled={!this.state.actualizarCelular}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label className="input-label-bold">
                                  Dirección Particular *
                                </label>
                                <input
                                  value={this.state.direccionParticular}
                                  name="direccion"
                                  onChange={(e) => {
                                    this.setState({
                                      direccionParticular:
                                        e.currentTarget.value,
                                    });
                                  }}
                                  type="text"
                                  className="input-box form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={{marginBottom:"1rem" }}>
                        <label className="input-label-bold">
                          Ubique su dirección particular en el mapa *
                        </label>
                        {this.state.latitud === undefined ? null : (
                        <MapaUbicacion 
                        departamento={this.state.departamento.label} 
                        barrio={this.state.barrio.label} 
                        direccion={this.state.direccionParticular}
                        latitud={this.state.latitud}
                        longitud={this.state.longitud}
                        ubiLatitudLongitud={this.ubiLatitudLongitud.bind(this)}></MapaUbicacion>
                        )}
                      </div>  

                      <div className="row">
                        <div className="col-lg-6 col-md-12">
                          {this.listaDepartamento()}
                        </div>
                     
                      
                        <div className="col-lg-6 col-md-12">{this.listaCiudades()}</div>
                     
                      
                        <div className="col-md-12">{this.listaBarrios()}</div>
                     
                        </div>
                      <hr />

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="input-label-bold">
                              Entidad Donde Trabaja *
                            </label>
                            <input
                              value={this.state.entidadLaboral}
                              name="entidad"
                              onChange={(e) => {
                                this.setState({
                                  entidadLaboral: e.currentTarget.value,
                                });
                              }}
                              type="text"
                              className="input-box form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="input-label-bold">Cargo *</label>
                            <input
                              value={this.state.cargo}
                              name="cargo"
                              onChange={(e) => {
                                this.setState({ cargo: e.currentTarget.value });
                              }}
                              type="text"
                              className="input-box form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-10">
                          <p>
                            ¿Ocupa o ha ocupado funciones públicas relevantes en
                            los últimos 5 años? ,o, ¿Es usted cónyuge,
                            concubino/a o pariente de una persona que ocupa o
                            haya ocupado funciones públicas relevantes en los
                            últimos 5 años? (*)
                          </p>
                        </div>
                        <div className="col-md-2">
                          <select
                            className="input-box form-control"
                            name="funcionPublica"
                            id="funcion_publica"
                            value={this.state.puestoPublico}
                            onChange={(e) => {
                              var value = e.currentTarget.value;
                              this.setState({
                                puestoPublico: value,
                              });

                              if (value === "S") {
                                this.setState({
                                  mensaje: PUBLICO_SI,
                                });
                              } else {
                                this.setState({
                                  mensaje: PUBLICO_NO,
                                });
                              }
                            }}
                          >
                            <option disabled value="">
                              -- Seleccione --
                            </option>
                            <option value="S">SI</option>
                            <option value="N">NO</option>
                          </select>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <MensajeUsuario
                          tipo="INFO"
                          titulo="(*) Persona Expuesta Políticamente (PEP):"
                          mensaje="Es toda persona, nacional o extranjera, que desempeña o ha desempeñado funciones 
                          públicas en algunos de los cargos detallados en los artículos 2°, 3° y 4° de la 
                          Resolución N°50/2019 - SEPRELAD, por la cual se aprueba el reglamento de identificación
                          de personas expuestas políticamente, y las medidas de debida diligencia a ser aplicadas 
                          por los sujetos obligados determinados en las normas ALA/CFT de la República del Paraguay, 
                          conforme a un enfoque basado en riesgos"
                          linkText="Resolución N°50/2019."
                          linkURL="https://cu24hs.cu.coop.py/archivos/Resoluci%c3%b3n_50-2019.pdf"
                        />
                      </div>               

                    </div>

                    <div className="card-footer">
                      <div className="row">
                        <div className="col-lg-10 col-md-6">
                        <label className="input-label-bold-obligatorio">
                        (*) Campos Obligatorios
                      </label>
                        </div>
                        <div className="col-lg-2 col-md-6">
                        <button
                        type="submit"
                        className="btn btn-cu-primary"
                        onClick={this.validate}
                      >
                      <FontAwesomeIcon icon={faFloppyDisk} />  Guardar
                      </button>
                      <a
                        ref={(a) => (this.linkSeprelad = a)}
                        href="https://cu24hs.cu.coop.py/archivos/Formulario-SEPRELAD.pdf"
                        hidden
                        target="_blank"
                      ></a>
                      <a
                        ref={(a) => (this.modalCtrlConfirm = a)}
                        href="#"
                        hidden
                        id="modalCtrlConfirm"
                        data-toggle="modal"
                        data-target="#idModalConfirm"
                      ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </form>
      </div>
    );
  }
}
